/* eslint-disable @typescript-eslint/no-unused-expressions */
import { useEffect, useState, KeyboardEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useForm } from 'react-hook-form'
import { IFormInputs } from '../NewUsers/NewUser.interface'
import {
  desativarVinculoOrganizacao,
  fetchAtivaDesativaUsuario,
  fetchEditarUsuario,
  fetchNovoUsuario,
  getOrganizacoesUsuario,
  getUsersAdm,
  getVinculoOrganizacao,
  salvarVinculoOrganizacao,
} from '../../services/UsersAdm/UsersAdm'
import { getOrganization } from '../../services/Organizations/getOrganizations'
import { formataCPF } from '../../utils/cpfMask'
import { normalizaCpfs, papelMultiVendedor } from '../Users/useUsers'

type GetUsersAdm = {
  ativo: boolean
  email: string
  id: number
  nome: string
  papel: 'ADMINISTRADOR'
}

export const useUsersAdm = () => {
  const navigate = useNavigate()
  const goToPage = (url: string) => {
    navigate(url)
  }

  const [searchValue, setSearchValue] = useState('')
  const [searchValueNome, setSearchValueNome] = useState('')
  const [searchValueEmail, setSearchValueEmail] = useState('')
  const [searchValueSenha, setSearchValueSenha] = useState('')
  const [searchValueConfirmarSenha, setSearchValueConfirmarSenha] = useState('')
  const [isShowFilter, setIsShowFilter] = useState(false)
  const [isShowSend, setIsShowSend] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [users, setUsers] = useState<GetUsersOrganizacaoType>(
    {} as GetUsersOrganizacaoType
  )
  const [isLoading, setIsLoading] = useState(true)
  const [checked, setChecked] = useState('USUARIO')
  const [status, setStatus] = useState(Boolean)
  const [modalInativar, setModalInativar] = useState(false)
  const [userId, setUserId] = useState<number>(0)

  const [campoObrigatorioNome, setCampoObrigatorioNome] = useState(false)
  const [campoObrigatorioEmail, setCampoObrigatorioEmail] = useState(false)
  const [campoObrigatorioSenha, setCampoObrigatorioSenha] = useState(false)
  const [campoObrigatorioConfirmarSenha, setCampoObrigatorioConfirmarSenha] =
    useState(false)
  const [senhaNaoConfere, setSenhaNaoConfere] = useState(false)
  const [emailConfere, setEmailConfere] = useState(false)

  // Vínculos do usuário com organizações (papel + CPF), só quando papel = USUARIO.
  const [organizacoesDisponiveis, setOrganizacoesDisponiveis] = useState<
    GetOrganizationsType[]
  >([])
  const [vinculos, setVinculos] = useState<VinculoOrganizacao[]>([])
  const [vinculosIniciais, setVinculosIniciais] = useState<
    VinculoOrganizacao[]
  >([])
  const [erroVinculo, setErroVinculo] = useState(false)
  const [carregandoVinculos, setCarregandoVinculos] = useState(false)

  const { control, register, setValue, watch } = useForm<IFormInputs>({
    mode: 'onChange',
    defaultValues: {
      isAdmin: false,
    },
  })

  const emailValidation = {
    required: true,
    pattern: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/,
  }

  const accessList: { [key: string]: string } = {
    ADMINISTRADOR: 'Administrador',
    USUARIO: 'Usuário',
  }

  const statusLabel = watch('isActive') ? 'Ativo' : 'Inativo'

  const fetchUsers = async () => {
    setIsLoading(true)
    const result = await getUsersAdm(searchValue, currentPage)
    setIsLoading(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      setUsers(result)
    }
  }

  const acaoUsuario = async (acao: string) => {
    setIsLoading(true)
    const result = await fetchAtivaDesativaUsuario(userId, acao)
    setIsLoading(false)
    if ('info' in result) {
      toast.success(result.info)
      fetchUsers()

      return
    }
    if ('message' in result) {
      toast.error(result.message)
    }
  }

  const requestDTO = {
    ativo: status,
    email: searchValueEmail,
    nome: searchValueNome,
    papel: checked,
    senha: searchValueSenha,
    senhaConfirmacao: searchValueConfirmarSenha,
  }

  const adicionarVinculo = () => {
    setVinculos(prev => [
      ...prev,
      {
        organizacaoId: 0,
        tenantId: '',
        papelOrganizacao: 'ADMINISTRADOR',
        cpfcnpj: '',
        cpfcnpjs: [''],
      },
    ])
  }

  const removerVinculo = (index: number) => {
    setVinculos(prev => prev.filter((_, i) => i !== index))
  }

  const handleChangeVinculoOrganizacao = (
    index: number,
    organizacaoId: number
  ) => {
    const organizacao = organizacoesDisponiveis.find(
      org => org.id === organizacaoId
    )
    setVinculos(prev =>
      prev.map((vinculo, i) =>
        i === index
          ? {
              ...vinculo,
              organizacaoId,
              tenantId: organizacao ? organizacao.tenantId : '',
            }
          : vinculo
      )
    )
  }

  const handleChangeVinculoPapel = (
    index: number,
    papelOrganizacao: PapelOrganizacaoType
  ) => {
    setVinculos(prev =>
      prev.map((vinculo, i) =>
        i === index
          ? {
              ...vinculo,
              papelOrganizacao,
              // CPF unico so vale para VENDEDOR; a lista, so para COORDENADOR/ASSISTENTE (PD-0004).
              cpfcnpj: papelOrganizacao === 'VENDEDOR' ? vinculo.cpfcnpj : '',
              cpfcnpjs: papelMultiVendedor(papelOrganizacao)
                ? vinculo.cpfcnpjs
                : [''],
            }
          : vinculo
      )
    )
  }

  const handleChangeVinculoCpfs = (index: number, cpfs: string[]) => {
    setVinculos(prev =>
      prev.map((vinculo, i) =>
        i === index ? { ...vinculo, cpfcnpjs: cpfs } : vinculo
      )
    )
  }

  const handleChangeVinculoCpf = (index: number, cpf: string) => {
    setVinculos(prev =>
      prev.map((vinculo, i) =>
        i === index ? { ...vinculo, cpfcnpj: formataCPF(cpf) } : vinculo
      )
    )
  }

  const vinculosValidos = () => {
    if (!checked.includes('USUARIO')) return true
    const ids = vinculos.map(vinculo => vinculo.organizacaoId)
    const temDuplicada = new Set(ids).size !== ids.length
    const temInvalido = vinculos.some(
      vinculo =>
        !vinculo.organizacaoId ||
        (vinculo.papelOrganizacao === 'VENDEDOR' &&
          vinculo.cpfcnpj.replace(/\D/g, '').length !== 11) ||
        (papelMultiVendedor(vinculo.papelOrganizacao) &&
          normalizaCpfs(vinculo.cpfcnpjs).length === 0)
    )
    return !temDuplicada && !temInvalido
  }

  // Mensagem de erro específica de uma linha de vínculo (só após tentar salvar).
  const erroVinculoLinha = (index: number) => {
    if (!erroVinculo) return ''
    const vinculo = vinculos[index]
    if (!vinculo.organizacaoId) return '*Selecione uma organização'
    const duplicada = vinculos.some(
      (outro, i) =>
        i !== index &&
        outro.organizacaoId !== 0 &&
        outro.organizacaoId === vinculo.organizacaoId
    )
    if (duplicada) return '*Organização repetida'
    if (
      vinculo.papelOrganizacao === 'VENDEDOR' &&
      vinculo.cpfcnpj.replace(/\D/g, '').length !== 11
    ) {
      return '*Informe um CPF válido (11 dígitos)'
    }
    if (
      papelMultiVendedor(vinculo.papelOrganizacao) &&
      normalizaCpfs(vinculo.cpfcnpjs).length === 0
    ) {
      return '*Informe ao menos um CPF válido (11 dígitos)'
    }
    return ''
  }

  // Orquestra os vínculos no frontend: salva/atualiza os desejados e desativa os removidos.
  // Se o papel deixou de ser USUARIO, o alvo é vazio (desativa todos os vínculos que existiam).
  const salvaVinculos = async (usuarioId: number) => {
    const desejados = checked.includes('USUARIO') ? vinculos : []

    const removidos = vinculosIniciais.filter(
      inicial =>
        !desejados.some(
          vinculo => vinculo.organizacaoId === inicial.organizacaoId
        )
    )

    const resultados = await Promise.all([
      ...removidos.map(vinculo =>
        desativarVinculoOrganizacao(vinculo.tenantId, usuarioId)
      ),
      ...desejados.map(vinculo =>
        salvarVinculoOrganizacao(vinculo.tenantId, usuarioId, {
          papelOrganizacao: vinculo.papelOrganizacao,
          ativo: true,
          cpfcnpj:
            vinculo.papelOrganizacao === 'VENDEDOR' ? vinculo.cpfcnpj : '',
          // Lista vazia nos papeis que nao usam escopo N: o backend limpa os CPFs do vinculo.
          cpfcnpjs: papelMultiVendedor(vinculo.papelOrganizacao)
            ? normalizaCpfs(vinculo.cpfcnpjs)
            : [],
        })
      ),
    ])

    return resultados.every(resultado => 'info' in resultado)
  }

  const criaNovoUsuario = async () => {
    const result = await fetchNovoUsuario(requestDTO)
    if ('id' in result && result.id) {
      const sucessoVinculos = await salvaVinculos(result.id)
      if (sucessoVinculos) {
        toast.success(result.info)
        goToPage('/adm-user')

        return
      }
      // Falha parcial: mantém o usuário na tela para tentar salvar os vínculos de novo
      // (salvar/desativar vínculo são idempotentes).
      toast.warning(
        'Usuário criado, mas houve falha ao vincular uma ou mais organizações. Revise e salve novamente.'
      )
      setUserId(result.id)

      return
    }
    toast.error(
      'message' in result ? result.message : 'Algo de errado aconteceu!'
    )
  }

  const editarUsuario = async () => {
    const result = await fetchEditarUsuario(userId, requestDTO)
    if ('info' in result) {
      const sucessoVinculos = await salvaVinculos(userId)
      if (sucessoVinculos) {
        toast.success(result.info)
        goToPage('/adm-user')

        return
      }
      toast.warning(
        'Usuário editado, mas houve falha ao salvar uma ou mais organizações. Revise e salve novamente.'
      )

      return
    }
    toast.error(result.message)
  }

  const fetchOrganizacoes = async () => {
    const result = await getOrganization()
    if (!('message' in result)) {
      setOrganizacoesDisponiveis(result.filter(org => org.ativo))
    }
  }

  // Pré-carrega na edição os vínculos ativos do usuário (papel + CPF por organização).
  const carregaVinculosExistentes = async (usuarioId: number) => {
    setCarregandoVinculos(true)
    const result = await getOrganizacoesUsuario(usuarioId)
    if ('message' in result) {
      toast.error('Não foi possível carregar as organizações do usuário.')
      setCarregandoVinculos(false)

      return
    }

    const detalhes = await Promise.all(
      result.organizacoes.map(async org => {
        const vinculo = await getVinculoOrganizacao(org.tenantId, usuarioId)
        if ('message' in vinculo) return { falhou: true, vinculo: null }
        if (!vinculo.ativo) return { falhou: false, vinculo: null }

        return {
          falhou: false,
          vinculo: {
            organizacaoId: org.id,
            tenantId: org.tenantId,
            papelOrganizacao: vinculo.papelOrganizacao,
            cpfcnpj: vinculo.cpfcnpj ? formataCPF(vinculo.cpfcnpj) : '',
            cpfcnpjs:
              vinculo.cpfcnpjs && vinculo.cpfcnpjs.length > 0
                ? vinculo.cpfcnpjs.map(formataCPF)
                : [''],
          },
        }
      })
    )

    const houveFalha = detalhes.some(item => item.falhou)
    const carregados = detalhes
      .map(item => item.vinculo)
      .filter((vinculo): vinculo is VinculoOrganizacao => vinculo !== null)

    setVinculos(carregados)
    setVinculosIniciais(carregados)
    if (houveFalha) {
      // Evita que o admin salve sobre uma lista incompleta sem perceber.
      toast.warning(
        'Algumas organizações do usuário não puderam ser carregadas. Revise antes de salvar.'
      )
    }
    setCarregandoVinculos(false)
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      fetchUsers()
    }
  }

  const handleEdit = (event: GetUsersAdm) => {
    localStorage.setItem('editUserAdm', JSON.stringify(event))
  }

  const handleClear = () => {
    localStorage.removeItem('editUserAdm')
  }

  const handleCheckboxChange = () => {
    if (checked.includes('ADMINISTRADOR')) {
      setChecked('USUARIO')
    } else if (checked.includes('USUARIO')) {
      setChecked('ADMINISTRADOR')
    }
  }

  const handleValidaEditarSalvar = () => {
    setCampoObrigatorioEmail(false)
    setCampoObrigatorioSenha(false)
    setEmailConfere(false)
    setCampoObrigatorioConfirmarSenha(false)
    setErroVinculo(false)

    if (searchValueNome.length === 0) {
      setCampoObrigatorioNome(true)
    } else if (searchValueEmail.length === 0) {
      setCampoObrigatorioEmail(true)
    } else if (!searchValueEmail.includes('@')) {
      setEmailConfere(true)
    } else if (searchValueSenha.length === 0 && userId === 0) {
      setCampoObrigatorioSenha(true)
    } else if (searchValueConfirmarSenha.length === 0 && userId === 0) {
      setCampoObrigatorioConfirmarSenha(true)
    } else if (searchValueSenha !== searchValueConfirmarSenha) {
      setSenhaNaoConfere(true)
    } else if (!vinculosValidos()) {
      setErroVinculo(true)
    } else {
      userId !== 0 ? editarUsuario() : criaNovoUsuario()
    }
  }

  const editUser = localStorage.getItem('editUserAdm')

  const showFilter = () => setIsShowFilter(!isShowFilter)
  const showSend = () => setIsShowSend(!isShowSend)
  const showInativar = () => setModalInativar(!modalInativar)
  const desativar = () => acaoUsuario('desativar')
  const ativar = () => acaoUsuario('ativar')

  useEffect(() => {
    fetchOrganizacoes()
    if (editUser) {
      const editar = JSON.parse(editUser)
      setSearchValueNome(editar.nome)
      setSearchValueEmail(editar.email)
      setStatus(editar.ativo)
      setChecked(editar.papel)
      setUserId(editar.id)
      if (editar.papel === 'USUARIO') {
        carregaVinculosExistentes(editar.id)
      }
    }
  }, [])

  useEffect(() => {
    fetchUsers()
  }, [currentPage])

  return {
    showSend,
    isShowSend,
    searchValue,
    setSearchValue,
    isShowFilter,
    currentPage,
    setCurrentPage,
    users,
    fetchUsers,
    isLoading,
    handleKeyDown,
    goToPage,
    showFilter,
    setIsShowSend,

    emailValidation,

    control,
    register,
    setValue,
    watch,

    accessList,

    searchValueNome,
    setSearchValueNome,
    searchValueEmail,
    setSearchValueEmail,
    searchValueSenha,
    setSearchValueSenha,
    searchValueConfirmarSenha,
    setSearchValueConfirmarSenha,

    statusLabel,

    criaNovoUsuario,
    handleEdit,
    editUser,
    handleClear,
    checked,
    handleCheckboxChange,

    setStatus,
    modalInativar,
    showInativar,
    userId,
    setUserId,
    ativar,
    desativar,
    status,
    editarUsuario,

    campoObrigatorioNome,
    setCampoObrigatorioNome,
    campoObrigatorioEmail,
    setCampoObrigatorioEmail,
    campoObrigatorioSenha,
    setCampoObrigatorioSenha,
    campoObrigatorioConfirmarSenha,
    setCampoObrigatorioConfirmarSenha,
    senhaNaoConfere,
    setSenhaNaoConfere,
    emailConfere,
    setEmailConfere,
    handleValidaEditarSalvar,

    organizacoesDisponiveis,
    vinculos,
    adicionarVinculo,
    removerVinculo,
    handleChangeVinculoOrganizacao,
    handleChangeVinculoPapel,
    handleChangeVinculoCpf,
    handleChangeVinculoCpfs,
    erroVinculoLinha,
    carregandoVinculos,
  }
}
